import Crud from '../views/Senha/Crud'
import Acompanhamento from '../views/Senha/Acompanhamento'
import Estatisticas from '../views/Senha/Estatisticas'
import Produtividade from '../views/Senha/Produtividade'
import Ocupacao from '../views/Senha/Ocupacao'
import Entity from '../views/Senha/Path'

let routes = {
  path: '/senhas',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/senhas',
      name: 'list-senhas',
      component: Crud,
      meta: {
        pageTitle: 'Lista de Senhas',
        breadcrumb: [
          {
            text: 'Senhas',
            active: true,
          },
        ],
      },
    },
    {
      path: '/acompanhamento',
      name: 'list-acompanhamento',
      component: Acompanhamento,
      meta: {
        pageTitle: 'Acompanhamento de Senhas',
        breadcrumb: [
          {
            text: 'Senhas',
            active: true,
          },
        ],
      },
    },
    {
      path: '/estatisticas',
      name: 'list-estatisticas',
      component: Estatisticas,
      meta: {
        pageTitle: 'Estatisticas das Senhas',
        breadcrumb: [
          {
            text: 'Senhas',
            active: true,
          },
        ],
      },
    },
    {
      path: '/produtividade',
      name: 'list-produtividade',
      component: Produtividade,
      meta: {
        pageTitle: 'Produtividade por Operador',
        breadcrumb: [
          {
            text: 'Relatório de Produtividade',
            active: true,
          },
        ],
      },
    },
    {
      path: '/ocupacao',
      name: 'list-ocupacao',
      component: Ocupacao,
      meta: {
        pageTitle: 'Ocupação da Unidade',
        breadcrumb: [
          {
            text: 'Relatório de Ocupação',
            active: true,
          },
        ],
      },
    },
    {
      path: '/senhas/path/:id?',
      name: 'PathSenha',
      component: Entity,
      meta: {
        pageTitle: 'Caminho da Senha',
        breadcrumb: [
          {
            text: 'Senhas',
            active: false,
            to: '/senhas',
          },
          {
            text: 'Caminho',
            active: true,
          }
        ],
      },
    },
  ]
};


export default routes
